module.exports = __webpack_public_path__ + "static/media/ss-loading-logo.25a4ee94.png";